import CouponCodeInput from './CouponCodeInput';

export default CouponCodeInput;
